import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Hero from "../components/hero";
import PhilosophyImage from "../assets/philosophy.jpeg";
import NarrativeTherapyImage from "../assets/narrativetherapy.jpeg";
import SolutionFocusedTherapyImage from "../assets/SFBT.jpeg";
import BrainworkingTherapyImage from "../assets/BWRT.jpeg";
import SFBTLink from "../assets/sfbt.png";
import BWRTLink from "../assets/bwrt.png";
import "../styles/universal.css";
import "../styles/approachPage.css";

const ApproachPage = () => {
  return (
    <div className="approach-page">
      <Navbar />
      <Hero
        title="My Approach"
        subtitle="Centred on your individuality, your abilities, and the context that shapes your life."
      />

      <div className="approach-content">
        <div className="philosophy-underlay">
          <div className="philosophy">
            <div className="philosophy-text">
              <h1>Therapeutic Philosophy</h1>
              <h2>No two journeys are the same.</h2>
              <p>
                My therapeutic work is grounded in a holistic, strength-based
                framework that recognises each client&#39;s unique context,
                abilities, and lived experience. While I make use of various
                therapeutic methodologies, tailored to what my clients require,
                the modalities from which I most regularly draw are{" "}
                <strong>
                  Narrative Therapy, Solution-Focused Brief Therapy (SFBT) and
                  BrainWorking® Recursive Therapy (BWRT).
                </strong>
              </p>
            </div>
            <img src={PhilosophyImage} alt="Therapeutic Philosophy"></img>
          </div>
        </div>
        <div className="narrative-therapy">
          <img src={NarrativeTherapyImage} alt="Narrative Therapy"></img>
          <div className="narrative-therapy-text">
            <h1>Narrative Therapy</h1>
            <h2>You are the author of your own life</h2>
            <p>
              <strong>Narrative therapy</strong> focuses on the stories we tell
              about ourselves and our lives. Narrative therapy focuses on the
              separation of the person from the problem. This approach helps
              individuals to identify their abilities and strengths. This
              therapy uses collaboration between client and counsellor to
              explore alternative perspectives and develop more empowering
              narratives that support growth, resilience, and change.
            </p>
          </div>
        </div>
        <div className="solution-focused-brief-therapy-underlay">
          <div className="solution-focused-brief-therapy">
            <div className="solution-focused-brief-therapy-text">
              <h1>Solution-Focused Brief Therapy</h1>
              <h2>Focus on your strengths, resources and goals</h2>
              <p>
                Rather than dwelling on problems, using{" "}
                <strong>Solution-Focused Brief Therapy (SFBT)</strong>, we
                identify what's working, envision your preferred future, and
                build practical steps to get there. I follow a short-term,
                empowering approach that's all about progress, not perfection.
              </p>
              <div className="solution-focused-therapy-link">
                <a
                  href="https://solutionfocused.net/what-is-solution-focused-therapy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={SFBTLink}
                    alt="Solution Focused Brief Therapy"
                  ></img>
                  <figcaption>Learn more about SFBT</figcaption>
                </a>
              </div>
            </div>
            <img
              src={SolutionFocusedTherapyImage}
              alt="Solution Focused Brief Therapy"
            ></img>
          </div>
        </div>
        <div className="brainworking-therapy">
          <img src={BrainworkingTherapyImage} alt="BrainWorking Therapy"></img>
          <div className="brainworking-therapy-text">
            <h1>BrainWorking® Recursive Therapy</h1>
            <h2>Rewire your brain</h2>
            <p>
              <strong>BrainWorking Recursive Therapy (BWRT)</strong> can be a
              very powerful method for working through trauma, fear or anxiety.
              The method taps into how your brain automatically processes
              information, helping you to interrupt unwanted emotional patterns
              right at the moment they begin. You'll focus on the part of your
              response that feels uncomfortable, and then shift toward how you'd
              prefer to feel and behave. The technique works by pausing that
              reaction before it travels deeper into the limbic system, also
              known as the emotional brain, giving you space to rewire the
              response before it fully forms.
            </p>
            <div className="brainworking-therapy-link">
              <a
                href="https://bwrtsa.co.za/about/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={BWRTLink} alt="BrainWorking Recursive Therapy"></img>
                <figcaption>Learn more about BWRT</figcaption>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ApproachPage;
